import { Col, Row } from "antd";
import MainProducts from "./components/MainProducts";
import FlashDealPage from "./components/FlashDealPage";
import AboutUs from "./components/AboutUs";
import Visible from "../../../components/Visible";
import {
  USER_LIST_ORDER_MENU_KEY,
  USER_PROFILE_MENU_KEY,
} from "../../../../applications/constants/AppConst";
import UserProfile from "../Profile";
import ListOrder from "../ListOrders";

interface ProductsProps {
  activeMenuNav: number;
  filterProduct: string;
  setActiveMenuNav: (val: number) => void;
  selectedSectionId?: string;
  setSelectedSectionId: (val: string) => void;
  setFilterProduct: (val: string) => void
}

function Products(props: ProductsProps) {
  const {
    activeMenuNav,
    filterProduct,
    setActiveMenuNav,
    selectedSectionId,
    setSelectedSectionId,
    setFilterProduct
  } = props;

  return (
    <Row className="products-container w-100 flex justify-content-center" style={{ height: 250 }}>
      <Col xs={24} sm={24} md={{ span: 16, offset: 4 }} lg={{ span: 16, offset: 4 }}>
        <Visible isVisible={activeMenuNav === USER_PROFILE_MENU_KEY}>
          <UserProfile setActiveMenuNav={setActiveMenuNav} />
        </Visible>
        <Visible isVisible={activeMenuNav === USER_LIST_ORDER_MENU_KEY}>
          <ListOrder setActiveMenuNav={setActiveMenuNav} />
        </Visible>
        <Visible isVisible={activeMenuNav === 1}>
          <MainProducts
            filterProduct={filterProduct}
            setFilterProduct={setFilterProduct}
            selectedSectionId={selectedSectionId}
            setSelectedSectionId={setSelectedSectionId}
          />
        </Visible>
        <Visible isVisible={activeMenuNav === 2}>
          <FlashDealPage />
        </Visible>
        <Visible isVisible={activeMenuNav === 3}>
          <AboutUs />
        </Visible>
      </Col>
      <Col xs={0} sm={0} md={{ span: 4 }} lg={{ span: 4 }}></Col>
    </Row>
  );
}
export default Products;
